// application.js
import request from 'superagent';
import config from '../config';

class OrderService {

  getUtm() {
    try{
      const cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split('=');
      if(cookie[0].trim()==='utm'){
        var obj = JSON.parse(decodeURIComponent(cookie[1]))
        return {utm: obj?.utm, utm_campaign: obj?.utm_campaign}
      }
    }
    const queryParamsString = window.location.search;
    const queryParams = new URLSearchParams(queryParamsString);
    var utm = ''
    var utm_campaign = queryParams.get('utm_campaign')
    if(utm_campaign===null){
      utm_campaign = ''
    }
    queryParams.entries().forEach((entry) => {
      if(entry[0].startsWith('utm_')){
        if(utm===''){
          utm = entry[1]
        }
        else{
          utm=utm+"_"+entry[1]
        }
      }
    }
    )

    return {utm, utm_campaign}
    }catch(error){
      console.log(`[UTM] Error parsing UTM`, error)
      return {utm:'', utm_campaign:''}
    }
  }

  deleteCookie() {
    document.cookie = "utm=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  // TRIP-164: pass the GA cookies through in the order body so the backend
  // can fire the server-side GA4 purchase with the same client/session as
  // the browser event (the API is cross-origin, cookies don't reach it).
  getGaCookies() {
    try {
      var out = {};
      var sessName = '_ga_' + (process.env.REACT_APP_MEASUREMENT_ID || '').replace('G-', '');
      document.cookie.split(';').forEach(function (c) {
        var i = c.indexOf('=');
        if (i < 0) return;
        var name = c.slice(0, i).trim();
        if (name === '_ga') out.ga_cookie = c.slice(i + 1).trim();
        if (sessName !== '_ga_' && name === sessName) out.ga_session_cookie = c.slice(i + 1).trim();
      });
      return out;
    } catch (e) {
      return {};
    }
  }

  // TRIP-158: OpenAI Ads attribution pass-through. Unlike the pixel, the
  // Conversions API does not capture these automatically: oppref is the
  // ad-click id persisted by src/index.js from the landing URL; __obref is
  // the pixel SDK's own browser-reference cookie. Sent in the order body so
  // the backend attaches them to the server-side order_created event —
  // without them, ad-blocked users' conversions count but never credit the
  // campaign.
  getOaiAttribution() {
    try {
      var out = {};
      document.cookie.split(';').forEach(function (c) {
        var i = c.indexOf('=');
        if (i < 0) return;
        var name = c.slice(0, i).trim();
        if (name === 'oai_oppref') out.oppref = decodeURIComponent(c.slice(i + 1).trim());
        if (name === '__obref') out.obref = decodeURIComponent(c.slice(i + 1).trim());
      });
      if (!out.oppref) {
        var fromUrl = new URLSearchParams(window.location.search).get('oppref');
        if (fromUrl) out.oppref = fromUrl;
      }
      return out;
    } catch (e) {
      return {};
    }
  }

  registerAndCreateOrder(body) {

    var utm = this.getUtm()
    if(utm.utm!==''){
      body.utm = utm.utm
    }
    if(utm.utm_campaign!==''){
      body.utm_campaign = utm.utm_campaign
    }
    Object.assign(body, this.getGaCookies())
    Object.assign(body, this.getOaiAttribution())

    return new Promise((resolve, reject) => {
      request.post(config.apiUrl+'orders/profile/new')
      .send(body)
      .set('Accept', 'application/json')
      .timeout({ response: 120000, deadline: 120000 })
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          this.deleteCookie()
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }

  createOrder(body,checkly_id) {
    console.log('[OrderService] createOrder', checkly_id)
    var utm = this.getUtm()
    if(utm.utm!==''){
      body.utm = utm.utm
    }
    if(utm.utm_campaign!==''){
      body.utm_campaign = utm.utm_campaign
    }
    Object.assign(body, this.getGaCookies())
    Object.assign(body, this.getOaiAttribution())
    return new Promise((resolve, reject) => {
      request.post(config.apiUrl+'orders/charge')
      .send(body)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem('token'))
      .set('X-CAPTCHA-PASS-KEY', checkly_id || '')
      .timeout({ response: 120000, deadline: 120000 })
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          this.deleteCookie()
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }

  createGift(body) {
    return new Promise((resolve, reject) => {
      request.post(config.apiUrl+'gift_cards')
      .send(body)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem('token'))
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }

  reschedule(body) {
    Object.assign(body, this.getGaCookies())
    if(localStorage.getItem('token')) {
      return new Promise((resolve, reject) => {
        request.post(config.apiUrl+'orders/reschedule-with-token')
        .send(body)
        .set('Accept', 'application/json')
        .set('Authorization', 'Bearer '+localStorage.getItem('token'))
        .timeout({ response: 120000, deadline: 120000 })
        .end((error, response) => {
          if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
            resolve(response.body);
          }
          else if(error){
            reject(error);
          }
          else{
            reject(response.body);
          }
        });
      })
    }
    else {
      return new Promise((resolve, reject) => {
        request.post(config.apiUrl+'orders/reschedule')
        .send(body)
        .set('Accept', 'application/json')
        .timeout({ response: 120000, deadline: 120000 })
        .end((error, response) => {
          if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
            resolve(response.body);
          }
          else if(error){
            reject(error);
          }
          else{
            reject(response.body);
          }
        });
      })
    } 
  }

  verifyCoupon(userId, code, date, isElite) {
    return new Promise((resolve, reject) => {
      let url = config.apiUrl+'coupons/verify/' + code + '/' + date;
      if(userId && isElite) {
        url = url + '?user=' + userId + '&elite=true';
      }
      else if(userId) {
        url = url + '?user=' + userId;
      }
      else if(isElite) {
        url = url + '?elite=true';
      }
      request.get(url)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem('token'))
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }

  verifyPromo(code, email) {
    return new Promise((resolve, reject) => {
      let url = config.apiUrl+'promotions/verify/' + encodeURIComponent(code) + '?email=' + encodeURIComponent(email);
      request.get(url)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem('token'))
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }

  verifyGiftCard(code) {
    return new Promise((resolve, reject) => {
      let url = config.apiUrl+'gift_cards/verify/' + code;
      request.get(url)
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem('token'))
      .end((error, response) => {
        if (!error && response.statusCode >= 200 && response.statusCode <= 304) {
          resolve(response.body);
        }
        else if(error){
          reject(error);
        }
        else{
          reject(response.body);
        }
      });
    })
  }
}

export default new OrderService();